import React from 'react';
import TinyEditor, {tinymce}  from '@ses-education/content-editor';
import './editor.scss';

/**
 * This just exports the editor and corresponding tinymce instance from the same place 
 */
export default (props) => <TinyEditor {...props} />
export {tinymce};
